import { Component, ContentChild, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CriteriaAddComponent } from '../criteria/criteria.add.component';
import { CriteriaDetails } from '../models/dto/criteria';
import { CriteriaOptionDetails } from '../models/dto/criteria-options-details';
import { AnswersAddDetails } from '../models/dto/answers';

@Component({
    selector: 'crtieria-jobs-template',
    template: `<div class="form-group joadd-template m-3">
                <div class="h3 grey40">{{criteria.title}}</div>
                <div class="small font-weight-bold grey40 float-60">Conditions désirables,<br/> souhaitables ou acceptables</div>
                <div class="float-30">
                    <div class="smile1 smile_pos-jadd"></div>
                    <div class="smile2 smile_pos-jadd"></div>
                    <div class="smile3 smile_pos-jadd"></div>
                </div>
                <div style="clear:both;"></div>
                <div class="grey88 small mt-1  mb-1">(Cochez si l'offre remplit ces conditions)</div>

                <div *ngFor="let opt of options">
                <div *ngIf="opt.importance < 4">
                    <label class="custom-control custom-checkbox grey40 label-jadd">
                    <input type="radio" id="offer{{criteria.id}}" name="offer{{criteria.id}}" class="custom-control-input" value="{{opt.id}}" (click)="clickRadio(opt.id)" [checked]="passChecked?.includes(opt.id)">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">{{opt.title}}</span>
                    </label>
                </div>
                </div>
                <hr class="mt-0" />
                <div class="small font-weight-bold grey40 float-60">Conditions non-acceptables</div>
                <div class="float-30"><div class="smile4 smile_pos-jadd"></div></div>
                <div style="clear:both;"></div>
                <div class="grey88 small mt-1  mb-1">(Cochez si l'offre remplit ces conditions)</div>

                <div *ngFor="let opt of options_unacceptable">
                <div *ngIf="opt.importance == 4">
                    <label class="custom-control custom-checkbox grey40 label-jadd">
                    <input type="radio" id="offer{{criteria.id}}" name="offer{{criteria.id}}" class="custom-control-input" value="{{opt.id}}" (click)="clickRadio(opt.id)" [checked]="passChecked?.includes(opt.id)">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">{{opt.title}}</span>
                    </label>
                </div>
                </div>
            </div>
`,
    styleUrls: ['./criteria-jobs.template.scss'],
})
export class CriteriaJobsTemplate implements OnChanges {
    @Input() form: FormGroup;
    @Input() formNumber: number;
    @Input() criteria: CriteriaDetails;
    @Input() passChecked: Array<string>;

    @Output() formOutput: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
    @Output() radioValue: EventEmitter<string> = new EventEmitter<string>();

    showTextInvalid = false;
    options: Array<CriteriaOptionDetails> = [];
    options_unacceptable: Array<CriteriaOptionDetails> = [];
    selectedOptions: Array<string> = [];

    constructor() { }

    addConditionTemplate(crt, selectedOptions) {
        this.formOutput.emit([{ crt, selectedOptions }]);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.criteria) {
            this.options = this.criteria.options.filter(x => x.importance < 4);
            this.options_unacceptable = this.criteria.options.filter(x => x.importance === 4);
        }
    }

    clickRadio(radioValue) {
        if (this.passChecked) {
            const selectedItemIndex = this.passChecked.indexOf(radioValue);
            if (selectedItemIndex !== -1) {
                this.passChecked.splice(selectedItemIndex, 1);
                this.deleteFromArrayTemplate(radioValue);
            } else {
                this.passChecked = [];
                this.selectedOptions = [];
                this.passChecked.push(radioValue);
                this.selectedOptions.push(radioValue);
            }
        } else {
            this.passChecked = [];
            this.passChecked.push(radioValue);
            this.selectedOptions.push(radioValue);
        }
        // const selectedItemIndex = this.passChecked.indexOf(radioValue);
        // if (selectedItemIndex !== -1) {
        //     this.passChecked.splice(selectedItemIndex, 1);
        //     this.deleteFromArrayTemplate(radioValue);
        // } else {
        //     this.passChecked = [];
        //     this.selectedOptions = [];
        //     this.passChecked.push(radioValue);
        //     this.selectedOptions.push(radioValue);
        // }
        this.addConditionTemplate(this.criteria.id, this.selectedOptions);
    }

    deleteFromArrayTemplate(crtId: string) {
        const selectedItemIndex = this.selectedOptions.indexOf(crtId);
        if (selectedItemIndex !== -1) {
            this.selectedOptions.splice(selectedItemIndex, 1);
        }
    }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/jobs/criteria-jobs.template.ts